import { YStack, XStack, Text } from 'tamagui'
import { CoverImage } from '@components/CoverImage'
import { useTranslation } from 'react-i18next'
import { Button } from '@components/Button'
import { IProductPage } from '@dtos/ProductPage'
import { navigateTo } from './helpers'
import { SectionTitle } from './SectionTitle'

// Conteúdos do combo (comboContent_listCombos): capa 86x86, nome do curso e
// botão outline para o preview do curso.
export function ComboCourses({ product }: { product: IProductPage }) {
  const { t } = useTranslation('ProductPage')
  const courses = product.path?.courses.nodes ?? []

  if (!courses.length) return null

  return (
    <YStack width="100%" marginTop={64} testID="product-combo">
      <SectionTitle>{t('combo.title')}</SectionTitle>
      <YStack>
        {courses.map((course) => (
          <XStack
            key={course.id}
            gap={24}
            paddingVertical={24}
            alignItems="center"
            borderBottomWidth={1}
            borderBottomColor="$border-muted"
          >
            {course.imageUrl ? (
              <CoverImage
                uri={course.imageUrl}
                alt={course.name ?? ''}
                width={86}
                height={86}
                borderRadius={4}
                style={{ flexShrink: 0 }}
              />
            ) : null}
            <Text
              color="$text-primary"
              fontSize={20}
              fontFamily="$mulishSemiBold"
              fontWeight="600"
              flexGrow={1}
              flexShrink={1}
            >
              {course.name}
            </Text>
            <Button
              variant="secondary"
              size="medium"
              flexShrink={0}
              onPress={() => navigateTo(course.previewPath)}
            >
              {t('combo.details')}
            </Button>
          </XStack>
        ))}
      </YStack>
    </YStack>
  )
}
